import { KEY_GET_SOURCE, SECTION_KEYWORD } from "./constans";

export const formatNumber = (num: number) => {
    return new Intl.NumberFormat('en-IN').format(num);
}

export const formatNumberWithCommas = (number: number | string = 0) => {
    if (String(number) === 'NaN') {
        return 0;
    }
    if (String(number) === 'null') {
        return 0;
    }
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const formatNumberWithoutCommas = (number: number | string = 0) => {
    return parseFloat(String(number).replace(/,/g, ''));
};

export const formatDateStringTo2Row = (date: string = '') => {
    const arr = String(date).split(' ');
    return `${arr[0]} <br/> ${arr[1]}`;
}

function updateKeys(obj: { [key: string]: any }, key_remove: string = ''): { [key: string]: any } {
    let updatedObj: { [key: string]: any } = {};

    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let newKey = key.includes(`${key_remove}`) ? key.replace(`${key_remove}`, '') : key;
            updatedObj[newKey] = obj[key];
        }
    }

    return updatedObj;
}

export const formatQueryParams = (query: any = {}, key_remove: string = '') => {
    const clone = !!key_remove ? updateKeys(structuredClone(query), key_remove) : structuredClone(query);

    delete clone.time_request;
    delete clone.time_request_out;
    delete clone.time_request_inner;
    delete clone.type_page_no_param;

    return clone;
}

export const formatLinkHTTPS = (linkString: string = '') => {
    if ((String(linkString).includes('https://') || String(linkString).includes('http://'))) {
        return linkString;
    }
    return `https://${linkString || ''}`;
}
export function isAfter4PMKoreanTime() {
    const currentTime = new Date();
    const currentHour = currentTime.getUTCHours(); // Get the current hour in UTC

    // Convert to Korean time zone (UTC+9)
    const koreanTimeHour = currentHour + 9; // UTC+9

    // Check if it's after 16:00 in Korean time
    if (koreanTimeHour >= 16) {
        return true;
    } else {
        return false;
    }
}

export const renderUrlSearchLookingUpByIP = (ip: string = '') => {
    return `https://whatismyipaddress.com/ip/${ip}`;
}

export const replaceHalfWithStar = (inputString: string) => {
    var length = inputString.length;
    var halfLength = Math.floor(length / 2);
    var starsCount = length - halfLength;
    var replacedString = inputString.substring(0, halfLength) + '*'.repeat(starsCount);
    return replacedString;
}

export const formatHour = (hour: number = 0) => {
    if (hour < 0 || hour > 23) {
        return 'Invalid hour';
    }

    let startHour = hour.toString().padStart(2, '0') + ":00";

    let endHour: any = hour + 1;
    if (endHour === 24) {
        endHour = "24:00";
    } else {
        endHour = endHour.toString().padStart(2, '0') + ":00";
    }

    return `${startHour} ~ ${endHour}`;
}

export const renderScriptURLOfInventory = (script_url: string = '', is_wrapper: boolean = false, target_id: string = '', key: string = '') => {
    if (!!target_id) {
        return `<div id="${target_id}">
        ${is_wrapper ? `<div id="ahtm-banner" style="width: 100%"><script  async src="${script_url}${!!key ? `?code=${key}` : ''}"></script></div>` : `<script async src="${script_url}"></script>`}
        </div>`;
    }
    if (is_wrapper) {
        return `<div id="ahtm-banner" style="width: 100%"><script  async src="${script_url}${!!key ? `?code=${key}` : ''}"></script></div>`;
    }
    return `<script async src="${script_url}"></script>`;
}

export const formatURL = (url: string) => {
    try {
        const urlObj: any = new URL(url);
        const formattedParams = [...urlObj?.searchParams?.entries()]
            .map(([key, value]) => `  &${key}=${decodeURIComponent(value)}`)
            .join("\n");
        return `${urlObj.origin}${urlObj.pathname}\n${formattedParams}`;
    } catch (error: any) {
        return `Invalid URL: ${error?.message}`;
    }
};

export const formatToJson = (_input: any) => {
    try {
        if (!!_input && (typeof _input === 'string')) {
            const jsonObject = JSON.parse(_input);
            return jsonObject;
        }
        return _input;
    } catch (error: any) {
        return _input;
    }
};

export const filterMediaOptions = (medias: any[]) => {
    return (medias || [])?.filter((_m: any) => !!_m?.is_partner);
};

export const formatGetSource = (_news_detail: any | null) => {
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.CONTENT_GOLD_PRICE)) {
        return ([_news_detail?.[`${KEY_GET_SOURCE[`${SECTION_KEYWORD.CONTENT_GOLD_PRICE}`]}`] || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.CONTENT_VOTE)) {
        return ([_news_detail?.[`${KEY_GET_SOURCE[`${SECTION_KEYWORD.CONTENT_VOTE}`]}`] || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.BOOSTING_V2)) {
        return ([_news_detail?.[`${KEY_GET_SOURCE?.[`${SECTION_KEYWORD.BOOSTING_V2}`]}`] || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.STOCK_NEWS)) {
        return ([_news_detail?.[`${KEY_GET_SOURCE?.[`${SECTION_KEYWORD.STOCK_NEWS}`]}`] || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.TOSS_STOCK_NEWS)) {
        return ([_news_detail?.[`${KEY_GET_SOURCE?.[`${SECTION_KEYWORD.TOSS_STOCK_NEWS}`]}`] || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.TRAVEL_NEWS)) {
        return (_news_detail?.source_travel_place?.places || {});
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.WEATHER_NEWS)) {
        return ([_news_detail?.source_weather || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.WEATHER_WARNING)) {
        return ([_news_detail?.source_weather_warning || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.GOVERNMENT_IMAGE_BASED_NEWS)) {
        return ([_news_detail || {}]);
    }
    if (String(_news_detail?.section) === String(SECTION_KEYWORD.GOVERNMENT_LOGO_BASED_NEWS)) {
        return ([_news_detail || {}]);
    }
    return _news_detail?.[`${KEY_GET_SOURCE?.[`${_news_detail?.section}`] || 'news_sources'}`];
};